module.exports = __webpack_public_path__ + "static/media/header-iphone.8dce94ff.png";